export const formatProfileName = (name?: string) => {
    if (!name) return
    if (name.includes('Challenger')) {
        const firstPart = name.slice(0, 10)
        const secondPart = name.slice(10, name.length)
        //@ts-ignore
        return `${firstPart} \n${secondPart}`
    } else {
        return name
    }
}
